import { useQuery } from "@tanstack/react-query";
import { API } from "./api";

const get = (url) => API.get(url).then((r) => r.data);

// Never retry a 404 — the resource is gone, fail fast so the not-found UI renders
const noRetryOn404 = (failureCount, error) =>
  error?.response?.status === 404 ? false : failureCount < 2;

export const useSettings = () =>
  useQuery({ queryKey: ["settings"], queryFn: () => get("/settings"), staleTime: 300_000 });

export const useServices = () =>
  useQuery({ queryKey: ["services"], queryFn: () => get("/services"), staleTime: 300_000 });

export const useService = (slug) =>
  useQuery({ queryKey: ["service", slug], queryFn: () => get(`/services/${slug}`), retry: noRetryOn404 });

export const useProjects = (params = {}) =>
  useQuery({
    queryKey: ["projects", params],
    queryFn: () => get("/projects" + buildQuery(params)),
    staleTime: 120_000,
  });

export const useProject = (slug) =>
  useQuery({ queryKey: ["project", slug], queryFn: () => get(`/projects/${slug}`), retry: noRetryOn404 });

export const useAreas = () =>
  useQuery({ queryKey: ["areas"], queryFn: () => get("/areas"), staleTime: 300_000 });

export const useArea = (slug) =>
  useQuery({ queryKey: ["area", slug], queryFn: () => get(`/areas/${slug}`), retry: noRetryOn404 });

export const useArticles = () =>
  useQuery({ queryKey: ["articles"], queryFn: () => get("/articles"), staleTime: 120_000 });

export const useArticle = (slug) =>
  useQuery({ queryKey: ["article", slug], queryFn: () => get(`/articles/${slug}`), retry: noRetryOn404 });

export const useTestimonials = () =>
  useQuery({ queryKey: ["testimonials"], queryFn: () => get("/testimonials"), staleTime: 120_000 });

function buildQuery(params) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => v && q.set(k, v));
  const s = q.toString();
  return s ? `?${s}` : "";
}
